import * as React from 'react'

import { CookieSettingsState, getCookieStatus } from './cookiebar.utils.mod'

export interface CookieSensitiveContentWrapperProps {
  children: React.ReactNode
  placeholder?: React.ReactNode
  groupId?: number
}

export class CookieSensitiveContentWrapper extends React.Component<
  CookieSensitiveContentWrapperProps,
  CookieSettingsState
> {
  constructor(props: CookieSensitiveContentWrapperProps) {
    super(props)

    this.state = {
      error: false,
      cookieStatus: getCookieStatus(this.props.groupId),
      unsubListener: () => {}
    }

    this.handleCookieEvent = this.handleCookieEvent.bind(this)
  }

  handleCookieEvent() {
    this.setState({ error: false, cookieStatus: getCookieStatus(this.props.groupId) })
  }

  componentDidMount() {
    window.addEventListener('CookiesUpdated', this.handleCookieEvent)
  }

  componentWillUnmount() {
    window.removeEventListener('CookiesUpdated', this.handleCookieEvent)
  }

  componentDidCatch() {
    this.setState({ error: true })
  }

  render() {
    const { children, groupId, placeholder } = this.props
    return (
      <div key={`${groupId}-${this.state.cookieStatus}-${this.state.error}`}>
        {this.state.error && this.state.cookieStatus == 'undecided' ? (
          placeholder ? (
            <div className={`error cookies`}>
              <div className={'cookies__inner gutter--m'}>
                <div className={'cookies__text text--styled'}>{placeholder}</div>
              </div>
            </div>
          ) : (
            <></>
          )
        ) : this.state.cookieStatus == 'accepted' ? (
          children
        ) : placeholder ? (
          <div className="cookies">
            <div className="cookies__inner gutter--m">
              <div className="cookies__text text--styled">{placeholder}</div>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    )
  }
}
